import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconPreview: React.FC<IconProps> = ({ color = '#000000', width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.9045 11.9473C26.9045 12.4875 26.5325 12.9589 26.0042 13.0821L21.1406 14.2216L20.0011 19.0853C19.8779 19.6112 19.4064 19.9855 18.8663 19.9855C18.3261 19.9855 17.8547 19.6112 17.7315 19.0853L16.5944 14.2216L11.7284 13.0821C11.2024 12.9589 10.8281 12.4875 10.8281 11.9473C10.8281 11.4072 11.2024 10.9358 11.7284 10.8126L16.5944 9.67306L17.7315 4.80941C17.8547 4.28348 18.3261 3.90918 18.8663 3.90918C19.4064 3.90918 19.8779 4.28348 20.0011 4.80941L21.1406 9.67306L26.0042 10.8126C26.5325 10.9358 26.9045 11.4072 26.9045 11.9473Z"
                fill={color}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.57031 8.28156C1.57031 8.00913 1.75983 7.77223 2.02754 7.713L4.46055 7.17759C4.46528 7.17759 4.47002 7.17522 4.47714 7.17048C4.48186 7.16338 4.48424 7.15864 4.48424 7.15391L5.01964 4.7209C5.07887 4.45319 5.31577 4.26367 5.58822 4.26367C5.86302 4.26367 6.09993 4.45319 6.15915 4.7209L6.69456 7.15391C6.69456 7.15864 6.69693 7.16338 6.70166 7.17048C6.7064 7.17522 6.71351 7.17759 6.71824 7.17759L9.15126 7.713C9.41659 7.77223 9.60848 8.00913 9.60848 8.28156C9.60848 8.55638 9.41659 8.79329 9.15126 8.85251L6.71824 9.38792C6.71351 9.38792 6.7064 9.39029 6.70166 9.39502C6.69693 9.39976 6.69456 9.40686 6.69456 9.4116L6.15915 11.8446C6.09993 12.1099 5.86302 12.3018 5.58822 12.3018C5.31577 12.3018 5.07887 12.1099 5.01964 11.8446L4.48424 9.4116C4.48424 9.40686 4.48186 9.39976 4.47714 9.39502C4.47002 9.39029 4.46528 9.38792 4.46055 9.38792L2.02754 8.85251C1.75983 8.79329 1.57031 8.55638 1.57031 8.28156Z"
                fill={color}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.4366 20.2947C12.4366 20.5671 12.2447 20.804 11.9794 20.8633L9.54637 21.3987C9.54164 21.3987 9.53453 21.401 9.52978 21.4058C9.52505 21.4129 9.52268 21.4176 9.52268 21.4223L8.98728 23.8554C8.92805 24.1231 8.69115 24.3126 8.41634 24.3126C8.1439 24.3126 7.90699 24.1231 7.84777 23.8554L7.31236 21.4223C7.31236 21.4176 7.30999 21.4129 7.30526 21.4058C7.29815 21.401 7.2934 21.3987 7.28868 21.3987L4.85566 20.8633C4.58796 20.804 4.39844 20.5671 4.39844 20.2947C4.39844 20.0199 4.58796 19.783 4.85566 19.7237L7.28868 19.1883C7.2934 19.1883 7.29815 19.186 7.30526 19.1812C7.30999 19.1765 7.31236 19.1694 7.31236 19.1646L7.84777 16.7316C7.90699 16.4663 8.1439 16.2744 8.41634 16.2744C8.69115 16.2744 8.92805 16.4663 8.98728 16.7316L9.52268 19.1646C9.52268 19.1694 9.52505 19.1765 9.52978 19.1812C9.53453 19.186 9.54164 19.1883 9.54637 19.1883L11.9794 19.7237C12.2447 19.783 12.4366 20.0199 12.4366 20.2947Z"
                fill={color}
            />
        </svg>
    );
};

export default IconPreview;
